/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PersonWithZugaengeDto } from '../../models/person-with-zugaenge-dto';

export interface DeleteExterne$Json$Params {

/**
 * ChipNr der externe Entität die gelöscht werden soll
 */
  chipNr: string;
}

export function deleteExterne$Json(http: HttpClient, rootUrl: string, params: DeleteExterne$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<PersonWithZugaengeDto>> {
  const rb = new RequestBuilder(rootUrl, deleteExterne$Json.PATH, 'delete');
  if (params) {
    rb.path('chipNr', params.chipNr, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PersonWithZugaengeDto>;
    })
  );
}

deleteExterne$Json.PATH = '/v1/personzugaenge/{chipNr}';
